import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnChanges,
  OnDestroy,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { tap } from 'rxjs';

import { SkillsIdeateFlowFacade } from '@core/tellent-skills-smart-ui';
import { SkillsIdeateResultJson } from '@core/tellent-skills-types';
import { TellentWebComponent } from '@core/tellent-types';

@Component({
  selector: 'x-generate-skills-dialog',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class TellentGenerateSkillsDialogWrapComponent implements OnChanges, OnDestroy {
  private readonly facade = inject(SkillsIdeateFlowFacade);
  private readonly destroyRef = inject(DestroyRef);
  #open = false;

  public open = input(false);
  public afterClosed = output<SkillsIdeateResultJson | undefined>();

  public ngOnChanges(): void {
    if (!this.open() || this.#open) return;

    this.#open = true;
    this.facade
      .startFlowAsTellentClientCompatibleStream()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(() => (this.#open = false)),
      )
      .subscribe(value => this.afterClosed.emit(value));
  }

  // Close the tellent-client dialog and complete the completion stream so the
  // host (e.g. Grow) doesn't leave an orphan dialog on the overlay if it
  // unmounts this WC mid-flow.
  public ngOnDestroy(): void {
    if (this.#open) this.facade.cancelFlow();
  }
}

export type TellentGenerateSkillsDialogWebComponent = TellentWebComponent<
  TellentGenerateSkillsDialogWrapComponent,
  'open' | 'afterClosed'
>;
